import ourStory from './ourStory';
import nav from './nav';
import home from './home';
import general from './general';
import support from './support';
import form from './form';
import trip from './trip';
import errors from './errors';

export default {
  gen: { ...general },
  nav: { ...nav },
  home: { ...home },
  ourStory: { ...ourStory },
  support: { ...support },
  form: { ...form },
  trip: { ...trip },
  error: { ...errors },
};